import { useQuery } from '@tanstack/react-query';
import { getTeamTrainingReport } from '../api/api';
import { useState } from 'react';

const useTeamTrainingReport = (teamId) => {
  const [selectedRange, setSelectedRange] = useState();

  const query = useQuery({
    queryKey: ['team-training-report', teamId, selectedRange],
    queryFn: () => getTeamTrainingReport(teamId, selectedRange),
    enabled: !!teamId,
  });

  return {
    ...query,
    selectedRange,
    setSelectedRange,
  };
};

export default useTeamTrainingReport;
